import React, { useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import PageHeading from '../../../../components/admin/common/PageHeading';
import { FaEye, FaEdit, FaTrash, FaSearch } from 'react-icons/fa';
import { Link } from 'react-router-dom';

// Sample student data with grade
const studentData = [
  {
    id: 1,
    name: 'Aarav Patil',
    email: 'aarav@gmail.com',
    age: 16,
    contact: '9876543210',
    address: 'Baner, Pune',
    grade: '10th',
  },
  {
    id: 2,
    name: 'Sneha Kulkarni',
    email: 'sneha.k@outlook.com',
    age: 18,
    contact: '9988776655',
    address: 'Kothrud, Pune',
    grade: '12th',
  },
  // Add more students
];

const ClgStudentList = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredStudents = studentData.filter(
    (student) =>
      student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      student.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <AdminAppBody
      content={
        <div className="container">
          {/* Header */}
          <div className="row align-items-center mb-3">
            <div className="col-md-6">
              <PageHeading
                title="Student List"
                subTitle="Manage all registered students and details."
              />
            </div>
            
          </div>

          {/* Search */}
          <div className="mb-4">
            <div className="input-group">
              <span className="input-group-text bg-white border-end-0">
                <FaSearch />
              </span>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Search by name or email"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          {/* Table */}
          <div className="card shadow-sm">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="bg-light text-uppercase small text-dark">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Age</th>
                      <th>Grade</th>
                      <th>Contact</th>
                      <th>Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredStudents.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center py-4">
                          No students found.
                        </td>
                      </tr>
                    ) : (
                      filteredStudents.map((student, index) => (
                        <tr key={student.id}>
                          <td>{index + 1}</td>
                          <td>{student.name}</td>
                          <td>{student.email}</td>
                          <td>{student.age}</td>
                          <td>{student.grade}</td>
                          <td>{student.contact}</td>
                          <td>{student.address}</td>
                        
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ClgStudentList;
